import { styled } from 'styled-components';
export default styled.span.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-176lqx0-0"
})(["", "{display:block;margin-bottom:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.vars.spacing_03;
});